module.exports = __webpack_public_path__ + "static/media/Karta Produktu_BGZBNPP_REVOLVINGCPI_3_3.2_2018_Cardif_Agro Ekspres.8e59e699.pdf";